var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.515625,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E4EBF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 52.9996C40.0547 53.0316 37.6189 53.0167 35.1647 52.955C29.9172 52.8232 27.2935 52.7573 25.4083 50.8649C23.523 48.9725 23.4686 46.4179 23.3596 41.3087C23.3246 39.6658 23.3246 38.0327 23.3596 36.3899C23.4686 31.2807 23.523 28.7261 25.4082 26.8337C27.2935 24.9413 29.9172 24.8754 35.1647 24.7436C38.3988 24.6623 41.6012 24.6623 44.8353 24.7436C50.0828 24.8754 52.7065 24.9413 54.5917 26.8337C56.477 28.7261 56.5314 31.2807 56.6404 36.3899C56.6579 37.2113 56.6667 38.0303 56.6667 38.8493",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 28.8496L34.8549 35.3906C39.0643 37.7804 40.9354 37.7804 45.1448 35.3906L56.6665 28.8496",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6665 47.1823C47.4857 46.3395 49.6661 43.0156 50.8332 43.0156M54.9998 47.1823C54.1806 46.3395 52.0002 43.0156 50.8332 43.0156M50.8332 43.0156V56.349",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/checkEmail.0eb30f5947e6ab00d17d425723786c9c.svg";
export { ForwardRef as ReactComponent };